//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import User from '~/components/User.vue';
import UserSelect from '~/components/UserSelect.vue';

export default {
  components: { User, UserSelect },

  props: {
    data: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      users: [],
      loader: false,
      userId: 0,
    };
  },

  computed: {
    tableConfig() {
      return [
        {
          width: 100,
          header: {
            type: 'text',
            caption: 'User',
          },
          cell: {
            type: 'slot',
            name: 'user',
          },
        },
      ];
    },
  },

  created() {
    this.loadUsers();
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('frontConfigAccesses', {
      getUserGroupsAction: 'getUserGroups',
      getGroupUsersAction: 'getGroupUsers',
      addUserToGroupAction: 'addUserToGroup',
      removeUserFromGroupAction: 'removeUserFromGroup',
    }),

    async loadUsers() {
      this.setGeneralProgress(true);
      this.loader = true;
      const { groupId } = this.data;
      const { users } = await this.getGroupUsersAction({ groupId });
      this.users = users;
      this.setGeneralProgress(false);
      this.loader = false;
    },

    remove(id) {
      const { groupId } = this.data;
      this.confirmAction({
        title: 'Are you sure you want to remove user from group?',
        callback: async () => {
          this.setGeneralProgress(true);
          await this.removeUserFromGroupAction({ userId: id, groupId });
          this.setGeneralProgress(false);
          await this.loadUsers();
          this.setSuccessNotification('User removed from group');
        },
      });
    },

    async addUser() {
      const { userId } = this;
      const { groupId } = this.data;
      this.setGeneralProgress(true);
      this.loader = true;
      await this.addUserToGroupAction({ userId, groupId });
      await this.loadUsers();
      this.setGeneralProgress(false);
      this.loader = false;
      this.setSuccessNotification('User added to group');
      this.userId = 0;
    },
  },
};
